import { Button } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import type DocumentWithMembershipStore from 'stores/DocumentWithMembershipStore';

import EditMemberModal from './EditMemberModal';

export interface EditMemberButtonProps {
  memberId: string;
  parentDocument: DocumentWithMembershipStore;
}

function EditMemberButton({ memberId, parentDocument }: EditMemberButtonProps) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Button
        disabled={!parentDocument.canEdit}
        onClick={() => setIsModalVisible(true)}
      >
        Edit
      </Button>

      {parentDocument.canEdit && (
        <EditMemberModal
          isVisible={isModalVisible}
          memberId={memberId}
          onClose={() => setIsModalVisible(false)}
          parentDocument={parentDocument}
        />
      )}
    </>
  );
}

export default observer(EditMemberButton);
